import Drawer from "@mui/material/Drawer";
import { styled } from "@mui/material/styles";

import { getFormatMedia } from "~/theme/utils";

import { SLIDE_MENU_CLASSES } from "./constants";

export const SlideMenuDrawer = styled(Drawer)(({ theme }) => {
  const formatMedia = getFormatMedia(theme);
  return {
    [`& .${SLIDE_MENU_CLASSES.drawer}`]: {
      width: "100%",
      [formatMedia.BREAKPOINT_TABLET]: {
        width: 400,
      },
    },
  };
});
